import {mapValues, isArray, isObject} from 'lodash'

export default function mapValuesDeep(object, iteratee) {
  if (isArray(object)) {
    return object.map(item => mapValuesDeep(item, iteratee))
  }

  if (isObject(object)) {
    return mapValues(object, (value, key) => {
      return isObject(value)
        ? mapValuesDeep(value, iteratee)
        : iteratee(value, key, object)
    })
  } else {
    return object
  }
}
